import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import AuthContext from "./auth/Context";
import Typography  from '@mui/material/Typography';
import * as utils from '../utils';
class Prompt extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={
      FormBase:null,
      value:"",
      open:false
    }
    this.options = {multiline:false}
    this.title = null
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    
  }
  /*async componentDidMount(){
    let self = this;
    this.onhashchange = ()=>{
      if(self.current_hash!=window.location.hash){
        self.setState({open:false});
      }
    }
    window.addEventListener("hashchange",this.onhashchange);
  }
  /*componentWillUnmount(){
    window.removeEventListener("hashchange",this.onhashchange)
  }*/
  async show(title,default_value,callback,options={multiline:false,accept_label:"",hide_accept_action:false,hide_cancel_action:false}){
    //this.current_hash = window.location.hash;

    this.title = title;
    this.callback = callback;
    this.options = options;
    this.listInfo =null;
    this.mediaQueryMatches = options.mediaQueryMatches ||  (window!=undefined && window.innerWidth<=540);
    if(this.options.form_code){
      const {default:FormBase} = await import(
        /* webpackPrefetch: true */
        /* webpackChunkName: "FormBase" */
        "./FormBase"
      );
      let code = this.options.form_code.toLowerCase()
      this.listInfo = await this.context.apis.asyncGetData(this.context.userInfo?this.context.getToken():this.context.config.public_token,"listinfo",{code},null,true,true);
      if(!this.listInfo){
        this.context.alert("Mã form không tồn tại")
        return;
      }
      let data = default_value||{};
      //Xử lý dữ liệu trước khi hiện form
      if(this.listInfo.on_init){
        try{
          this.context.setProgressStatus(true);
          let on_init = this.listInfo.on_init;
          on_init = `return (async ()=>{
            ${on_init}
          })();`
          const func = new Function("master","detail","API","context","utils","action","mediaQueryMatches",on_init);
          await func(data,data,this.context.apis,this.context,utils,"ADD",this.mediaQueryMatches);
          this.context.setProgressStatus(false);
        }catch(e){
          return this.context.alert(e.message||e.error ||e,null,"red");
        }
      }
      //
      this.setState({
        FormBase:<FormBase  
          mediaQueryMatches ={this.mediaQueryMatches}
          backgroundColorFieldsTab="white"
          /*code={this.options.form_code} */
          fields = {this.listInfo.fields}
          history={this.options.history} 
          parent={this.options.parent}
          data={data}
          handleValueChanged={(value)=>{
            this.setState({value})
          }}/>,
        value:data,
        open:true
      })
    }else{
      this.setState({value:default_value,open:true,FormBase:null});
    }
  }
  async handleOk(){
    if(this.listInfo && this.listInfo.expression_check_save){
      try{
        this.context.setProgressStatus(true);
        let body_func_check = this.listInfo.expression_check_save;
        body_func_check = `return (async ()=>{
          ${body_func_check}
        })();`
        const func = new Function("master","detail","API","context","utils","parent",body_func_check);
        let rs = await func(this.state.value,this.state.value,this.context.apis,this.context,utils,this);
        this.context.setProgressStatus(false);
        if(rs && rs.error){
          return this.context.alert(rs.error,null,"red");
        }
        this.setState({open:false},()=>{
          if(this.callback){
            this.callback(this.state.value);
          }
        });
      }catch(e){
        return this.context.alert(e.message||e.error ||e,null,"red");
      }
    }else{
      this.setState({open:false},()=>{
        if(this.callback){
          this.callback(this.state.value);
        }
      });
    }
    
  }
  handleCancel(){
    //console.log("close promp")
    this.setState({open:false,value:null},()=>{
      if(this.callback){
        this.callback(null);
      }
    });
  }
  handleValueChange(event){
    this.setState({
      value:(event.target.value||"")
    })
  }
  render(){
    const {getLabel} = this.context.apis;
    if(!this.state.open) return null;
    return (
      <Dialog
        fullScreen={this.mediaQueryMatches?true:false}
        maxWidth={(this.listInfo||{}).form_size||'sm'}
        fullWidth={true}
        open={this.state.open}
        onClose={this.handleCancel}
        slotProps={{
          paper:{
            style:{backgroundColor:"transparent"}
          }
        }}
      >
        {!this.mediaQueryMatches && <DialogTitle style={{backgroundColor:this.context.config.formHeaderColor,color:this.context.config.mainTextColor}}>
          <Grid container direction="row" justifyContent="space-between">
            <Grid>
              <Typography  variant="inherit" >
                {this.title}
              </Typography>
              
            </Grid>
            <Grid
              style={{display:'flex',flexDirection:"row",alignItems:"center",justifyContent:'flex-end',paddingLeft:10}}>
              {!this.options.hide_accept_action && <Button variant="contained" color="info" onClick={this.handleOk}>
                  {this.options.accept_label || getLabel("Nhận")}
              </Button>}
              {!this.options.hide_cancel_action && <Button variant="contained"  color="secondary" onClick={this.handleCancel} style={{marginLeft:5}}>
                  {getLabel("Huỷ")}
              </Button>}
            </Grid>
          </Grid>
        </DialogTitle>}
        <DialogContent style={{padding:0,display:"flex",flexDirection:"column",justifyContent:"flex-end",height:"100%"}}>
          {this.mediaQueryMatches && <div style={{backgroundColor:"white",padding:5}}><Typography variant="h5">
            {this.title}
          </Typography></div>}
          <div style={{backgroundColor:"white"}}>
            {
              this.state.FormBase 
              ||
              <div style={{padding:10}}>
                <TextField variant="outlined" multiline={this.options.multiline} autoFocus={!this.mediaQueryMatches} fullWidth value={this.state.value} onChange={this.handleValueChange.bind(this)}/>
              </div>
            }
          </div>
          {this.mediaQueryMatches && <div item  style={{backgroundColor:'white',display:'flex',flexDirection:"row",justifyContent:"center",alignItems:"center",padding:20}}>
              <Button size="large" variant="contained" color="info" disabled={!this.state.value} onClick={this.handleOk}>
                  {this.options.accept_label || getLabel("Nhận")}
              </Button>
              {!this.options.hide_cancel_action && <Button
                size="large"
                variant="contained"
                color="secondary"
                onClick={this.handleCancel}
                style={{marginLeft:20}}>
                  {getLabel("Huỷ")}
              </Button>}
          </div>}
        </DialogContent>
      </Dialog>
    );
  }
}
Prompt.contextType = AuthContext;
export default  Prompt;